import { z } from 'zod';
// subscription status
export const subscriptionStatusEnum = z.enum([
    'TRIALING',
    'INCOMPLETE',
    'INCOMPLETE_EXPIRED',
    'ACTIVE',
    'PAST_DUE',
    'CANCELED',
    'UNPAID',
]);
// Create the subscription schema with all fields matching the Java model
export const subscriptionSchema = z.object({
    id: z.string(),
    status: subscriptionStatusEnum,
    trialEndsAt: z.string().datetime().optional(),
    stripeCustomerEmail: z.string().optional(),
    currentPeriodStart: z.string().datetime(),
    currentPeriodEnd: z.string().datetime(),
    canceling: z.boolean(),
    canceledAt: z.string().datetime().optional(),
    endedAt: z.string().datetime().optional(),
});
